import { Button } from '@factorialco/deprecated-design-system'
import { PayrollResultFragment } from 'generated/resources/graphql'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

interface Props {
  result: PayrollResultFragment
  disabled: boolean
  onClose: () => void
  onDelete: (result: PayrollResultFragment) => void
}

const DeleteModal = ({ result, disabled, onClose, onDelete }: Props) => {
  return (
    <Modal
      title={i18n.t(
        'compensations.PayrollRunCompensationsList.manage_payroll_results.modal.actions.delete_confirm.title'
      )}
      description={i18n.t(
        'compensations.PayrollRunCompensationsList.manage_payroll_results.modal.actions.delete_confirm.description'
      )}
      illustration="delete"
      onClose={onClose}
      footer={
        <>
          <Button onClick={onClose} disabled={disabled} type="secondary">
            {i18n.t('common.cancel')}
          </Button>
          <Button onClick={() => onDelete(result)} type="primary" disabled={disabled}>
            {i18n.t(
              'compensations.PayrollRunCompensationsList.manage_payroll_results.modal.actions.delete_confirm.delete'
            )}
          </Button>
        </>
      }
    />
  )
}

export default DeleteModal
